import './App.css';

import Header from "./components/Header/Header";
import {Column} from './components/Flex';

import styled from '@emotion/styled';

import "normalize.css";

import {
  Routes,
  Route
} from "react-router-dom";

// import Auth from './components/Auth';
import Marketplace from './components/Marketplace';
// import NFTWallet from './components/NFTWallet';
import Address from './components/Address';
import Collection from './components/Collection';
import NftPage from './components/NftPage';
import CreatePage from './components/CreatePage';
import DaoPage from './components/DaoPage';

const Root = styled(Column)`
  width: 100%;
  align-items: center;
  background: #fff;
  min-height: 100vh;
`;


function App() {
  return (
    <Root>
      <Header/>
      <Routes>
        <Route path="/" element={<Marketplace/>}/>
        <Route path="/create" element={<CreatePage/>}/>
        <Route path="/wallet" element={<Address isWallet={true}/>}/>
        <Route path="/wallet/burn" element={<Address isWallet={true} burn={true}/>}/>
        <Route path="/address/:address" element={ <Address/> }/>
        <Route path="/collection/:address/:collection" element={ <Collection/> }/>
        <Route path="/nft/:nftId" element={ <NftPage/> }/>
        <Route path="/nft/burn/:nftId" element={ <NftPage burn={true}/> }/>
        <Route path="/auction/:nftId" element={ <NftPage auction={true}/> }/>
        <Route path="/dao" element={ <DaoPage /> }/>
      </Routes>
    </Root>
  );
}

export default App;
